import React, { useEffect } from 'react';
import { gsap } from 'gsap';
import '../Connect/Connect.css';
import { Link } from 'react-router-dom';

const Connect = () => {
  useEffect(() => {
    // Select all spans within the .teach-logo
    gsap.fromTo(
      ".teach-logo span",
      { opacity: 0, scale: 0 },
      {
        opacity: 1,
        scale: 1,
        duration: 0.5,
        stagger: 0.1, // Stagger the animations
        repeat: -1, // Repeat the animation
        yoyo: true, // Reverse the animation
        ease: "power2.inOut",
      }
    );
  }, []);

  const logoText = "Company Name";

  return (
    <>
      <div className="teach-container">
        <div className="teach-content">
          <h1 className="teach-logo">
            {logoText.split("").map((char, index) => (
              <span key={index}>{char === " " ? "\u00A0" : char}</span> // Handle spaces
            ))}
          </h1>
          <div className="sp">
            <span className="teach-tagline">Happy To Discuss About Your Requirement</span>
            <span className="teach-tagline">We understand the needs for professionalism</span>
          </div>
        </div>
        <div className="teach-buttons">
          <Link to="/contactus">
            <button className="ca-button">Contact us →</button>
          </Link>
        </div>
      </div>
    </>
  );
};

export default Connect;
